import React, { Component } from 'react';
import { Tabs } from 'antd';

import FilterGroup from '../../../../components/FilterGroup/FilterGroup';
import CustomerList from './components/CustomerList/CustomerList';
import CustomerRanking from './components/CustomerRanking/CustomerRanking';

const { TabPane } = Tabs;

export class CustomerPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'all',
            filters: {},
            searchText: ''
        }
    }

    componentDidMount() {
        const { location } = this.props;
        const { hash } = location;

        if (hash) {
            this.setState({ activeTab: hash.substring(1) })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const { hash } = location;

        if (hash !== prevProps.location.hash)
            this.setState({ activeTab: hash.substring(1) })
    }

    render() {
        const { history } = this.props;
        const { activeTab, filters, searchText } = this.state;

        return (
            <div className="CustomerPage ListPage">
                <div className="page-header">
                    <h2>Customer</h2>
                    <FilterGroup
                        disabled={activeTab !== 'all'}
                        filterList={[]}
                        onChange={(filters, searchText) => this.setState({ filters, searchText })}
                    />
                </div>
                <Tabs 
                    activeKey={activeTab}
                    type="card" 
                    tabBarGutter={5}
                    onChange={(key) => history.push(`/dashboard/admin/customer#${key}`)}
                >
                    <TabPane tab="All" key="all">
                        <CustomerList
                            isActive={activeTab === 'all'}
                            filters={filters}
                            searchText={searchText}
                        />
                    </TabPane>
                    <TabPane tab="Ranking" key="ranking">
                        <CustomerRanking isActive={activeTab === 'ranking'}/>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

export default CustomerPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerPage/CustomerPage.js